import React, { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Typography } from '@material-tailwind/react';
import { useSelector } from 'react-redux';
import { useGetPecas } from '../../hook/getPecas';
import { ProdutoModalInfo } from '../Modal/ProdutoModalInfo';
const columns = [
  { id: 'produto', label: 'Produto', with: '100%' },
  { id: 'quantidade', label: 'Necessario', with: 130, align: 'center' },
  { id: 'produtoInEstoque', label: 'Estoque', with: 130, css: true, align: 'center' },
];

export default function ({ idGet = false }) {
  const { result, patch, loading, reset } = useGetPecas();
  const { theme } = useSelector((state) => state.auth);
  const { productos } = useSelector((state) => state.product);

  useEffect(() => {
    if (result) {
      document.title = result[0]?.linha || 'Arvore de peças';
    }
    return () => {
      document.title = 'Duarts.dev';
    };
  }, [result]);

  const [viewProduct, setViewProduct] = useState(false);

  const handleViewProduct = (produto) => {
    const view = productos.find((produt) => produt.winthor === produto.produtoWinthor);
    setViewProduct(view);
  };

  const handleCloseViewProdut = () => {
    setViewProduct(false);
  };

  useEffect(() => {
    if (loading) {
      document.body.style.cursor = 'wait'; // Cursor de loading
    } else {
      document.body.style.cursor = 'default'; // Cursor normal
    }
  }, [loading]);

  useEffect(() => {
    if (idGet) {
      patch(idGet);
    } else {
      reset();
    }
  }, [idGet]);

  return (
    <>
      <Paper
        sx={{
          width: '100%',
          overflow: 'hidden',
          background: theme ? '#b0bec5' : '#eeeeee',
          height: 'auto',
        }}
      >
        <TableContainer sx={{ maxHeight: 550, height: '90%' }}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{
                      width: column.width,
                      borderColor: 'transparent',
                      color: theme && '#fff',
                    }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {result &&
                result.length > 0 &&
                result.map((row, index) => (
                  <TableRow
                    hover
                    tabIndex={-1}
                    key={index}
                    sx={{
                      '&:nth-of-type(odd)': {
                        backgroundColor: 'rgba(0, 0, 0, 0.2)', // Cor para as linhas ímpares
                      },
                    }}
                  >
                    {columns.map((column, index) => {
                      const value = row[column.id];
                      return (
                        <TableCell
                          key={index}
                          align={column.align}
                          sx={{
                            padding: '0px 0px 0px 16px',
                          }}
                        >
                          {column.id === 'produto' ? (
                            <Typography
                              variant="small"
                              className=" font-bold dark:hover:text-blue-600 min-w-28 cursor-pointer hover:underline inline "
                              onDoubleClick={() => handleViewProduct(row)}
                            >
                              {value}
                            </Typography>
                          ) : (
                            <Typography
                              variant="small"
                              color="black"
                              className={`${value == 0 && 'text-red-500'}  font-normal  ${
                                column.css && 'p-2 bg-darkRbgEstq  block lg:bg-transparent'
                              }`}
                            >
                              {value}
                            </Typography>
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))}

              {!loading && result && result.length === 0 && (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    Nenhuma peça cadastrada
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      <ProdutoModalInfo produto={viewProduct} handleProduto={handleCloseViewProdut} />
    </>
  );
}
